// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Google = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M9.384 46.524c.34-20.349 19.047-38.17 39.396-37.49 9.75-.454 18.915 3.79 26.383 9.75-3.187 3.62-6.487 7.11-10.014 10.371-8.976-6.205-21.744-7.977-30.72-.81C21.585 37.226 21 58.196 33.353 67.758c12.012 10.9 34.718 5.488 38.037-11.202-7.524-.114-15.068 0-22.592-.245-.019-4.489-.038-8.977-.019-13.466 12.58-.037 25.157-.056 37.755.038.755 10.561-.64 21.801-7.128 30.533-9.826 13.823-29.552 17.858-44.94 11.937C19.02 79.47 8.082 63.157 9.383 46.524"
			fillRule="evenodd"
		/>
	</svg>
);
export default Google;
